import { createSelector } from 'reselect';
import expandedModulesSelector from './expandedModules';

export default (selector: () => string | undefined) =>
    createSelector(
        expandedModulesSelector,
        selector,
        (modules, code) => modules.find((item) => item.code === code)?.id,
    );
